module.exports = __webpack_public_path__ + "files/42212ffccde2d74b0e7142722ff6c3c4.png";